// extracted by css-extract-rspack-plugin
export default {"editor":"eAEq9"};